import React from 'react';
import { Modal, Fade, Backdrop } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { isMobile } from 'react-device-detect';
import ButtonBase from '../Buttons/ButtonBase';

const useStyles = makeStyles({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        display: 'flex',
        flexDirection: 'Column',
        width: isMobile ? 360 : 384,
        borderRadius: 4,
        padding: isMobile ? 20 : 24,
        margin: isMobile ? 10 : 0,
        boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
        backgroundColor: 'white',
        '&:focus': {
            outline: 'none',
        },
    },
    infoWrapper: {
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'flex-start',
    },
    name: {
        fontSize: 22,
        color: '#10587f',
        textAlign: 'left',
        marginBottom: 16,
        fontWeight: 'bold',
    },
    subname: {
        fontSize: 16,
        color: '#484848',
        textAlign: 'left',
        margin: isMobile ? '0 30px 20px 0' :  '0 50px 20px 0',
    },
    buttons: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    ButtonBase: {
        margin: '0 0 0 16px',
        minWidth: '136px !important',
        width: 'initial',
    },
})

function PopUp({ 
    open,
    handleClose,
    title,
    subtitle,
    content,
    primaryButton,
    primaryButtonVariant,
    primaryButtonText,
    secondaryButton,
    secondaryButtonVariant,
    secondaryOptionalFunctionForCancel,
    primaryFunction })
{
    const classes = useStyles()

    const closeModal = () => {
      handleClose()
      if (secondaryOptionalFunctionForCancel) {
        secondaryOptionalFunctionForCancel()
      }
    }
 
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div className={classes.infoWrapper}>
              {title ?
                <div>
                  <p className={classes.name}>
                    {title}
                  </p>
                </div> :
                null
              }
              
              {subtitle ?
                <div className={classes.subname}>
                  <span>
                    {subtitle}
                  </span>
                </div> :
                null
              }
              
              {content ? content : null}
              
              <div className={classes.buttons}>
                {secondaryButton ?
                    <ButtonBase
                        type="submit"
                        onClick={closeModal}
                        variant={secondaryButtonVariant}
                        className={classes.ButtonBase}
                    >
                        Cancelar
                    </ButtonBase> :
                    null
                }
                
                {primaryButton ?
                    <ButtonBase
                        type="submit"
                        onClick={primaryFunction}
                        variant={primaryButtonVariant}
                        className={classes.ButtonBase}
                    >
                        {primaryButtonText}
                    </ButtonBase> :
                    null
                }
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    )
}

export default PopUp;
